import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { Shield, AlertTriangle } from 'lucide-react';

const ProtectedModule = ({ module, children, fallback = null }) => {
  const { hasPermission, loading, userLevel } = usePermissions();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        padding: '40px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #6c757d',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '16px'
        }}></div>
        <p style={{ color: '#666' }}>Verificando permissões...</p>
        <style jsx>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!hasPermission(module)) {
    if (fallback) {
      return fallback;
    }

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '400px',
        padding: '40px',
        textAlign: 'center',
        backgroundColor: '#f8f9fa',
        borderRadius: '12px',
        margin: '20px',
        border: '1px solid #e9ecef'
      }}>
        <AlertTriangle size={64} color="#dc3545" style={{ marginBottom: '20px' }} />
        <h2 style={{ 
          color: '#dc3545', 
          marginBottom: '12px',
          fontSize: '24px'
        }}>
          Acesso Negado
        </h2>
        <p style={{ 
          color: '#666', 
          marginBottom: '8px',
          fontSize: '16px',
          maxWidth: '400px'
        }}>
          Você não tem permissão para acessar este módulo.
        </p>
        <p style={{ 
          color: '#888', 
          fontSize: '14px',
          marginBottom: '20px'
        }}>
          Seu nível de acesso: <strong>{userLevel || 'Não definido'}</strong>
        </p>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px 20px',
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeaa7',
          borderRadius: '6px',
          fontSize: '14px',
          color: '#856404'
        }}>
          <Shield size={16} />
          Entre em contato com o administrador para solicitar acesso
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedModule;